import { useEffect, useRef } from 'react';

export function useUpdateEffect(callback, dependencies) {
  const hasMounted = useRef(false);

  useEffect(() => {
    if (hasMounted.current) {
      return callback();
    }

    hasMounted.current = true;
  }, dependencies);
}

export function useIgnoreFirstUpdateEffect(callback, dependencies) {
    const changeCount = useRef(0);
  
    useEffect(() => {
      if (changeCount.current < 2) {
        changeCount.current += 1;
        return;
      }
  
      return callback();
    }, dependencies);
  }